export default __webpack_public_path__ + "static/media/bedroom4.205caba1.webp";